<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path
      fill="#D3D4D7"
      fill-rule="evenodd"
      d="M1.5 4.543A3.043 3.043 0 0 1 4.543 1.5h14.913A3.043 3.043 0 0 1 22.5 4.543v14.913a3.043 3.043 0 0 1-3.044 3.044H4.543A3.043 3.043 0 0 1 1.5 19.456V4.543Zm3.043-1.217c-.672 0-1.217.545-1.217 1.217v14.913c0 .673.545 1.218 1.217 1.218h14.913c.673 0 1.218-.545 1.218-1.218V4.543c0-.672-.545-1.217-1.218-1.217H4.543Z"
      clip-rule="evenodd"
    />
  </svg>
</template>
